import React from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from '@/components/v11/shared/Breadcrumb';

const isProfile = (pathname: string) => pathname === '/v11/profile';

/** True on the pages the breadcrumb belongs to. */
export function hasBreadcrumb(pathname: string): boolean {
  return (
    pathname === '/v11/settings' || pathname.startsWith('/v11/settings/') || isProfile(pathname)
  );
}

/**
 * "Workspace › Account Settings" on the settings pages and "Workspace ›
 * Profile" on the profile (AL-1861), as CT-0 draws them.
 */
export const SettingsBreadcrumb: React.FC<{ readonly pathname?: string }> = ({ pathname = '' }) => {
  const { t } = useTranslation();

  return (
    <Breadcrumb
      variant="settings"
      testId="settings-breadcrumb"
      ariaLabel={t('app.v11.shell.breadcrumb.label')}
      items={[
        { label: t('app.v11.shell.sections.workspace') },
        {
          label: isProfile(pathname)
            ? t('app.v11.profile.header.title')
            : t('app.v11.userMenu.accountSettings'),
        },
      ]}
    />
  );
};
